import { getEventId } from "../../events.js";
function getOrientation() {
  var _a;
  const screenOrientation = ((_a = screen.orientation) == null ? void 0 : _a.type) || screen.mozOrientation || screen.msOrientation;
  return ["portrait-primary", "portrait-secondary"].includes(screenOrientation) ? "portrait" : " landscape";
}
function createLegacyPayload(eventName, eventPayload, utmParamsFromSession, additionalData) {
  var _a, _b, _c, _d, _e;
  const {
    utmParams = utmParamsFromSession,
    env,
    sessionId,
    agent,
    isMobile,
    distribution,
    organizationId,
    isAutoplay,
    isInteractive,
    pixelId,
    videoUrl
  } = additionalData;
  const eventId = getEventId(eventName);
  if (eventId == null)
    return;
  const { activation = null, ...rest } = eventPayload;
  let body = {
    ...rest,
    type: eventName,
    event: { event: eventId },
    e: eventId
  };
  if (activation != null) {
    const campaigns = ((_a = activation.instance) == null ? void 0 : _a.campaign) != null ? [{
      id: activation.instance.campaign.id,
      scheduleId: activation.instance.campaign.scheduleId
    }] : null;
    body = {
      ...body,
      campaigns,
      meta: activation.id != null ? `${activation.id}` : null,
      flow_from: activation.id != null ? `${activation.id}` : null,
      metaName: activation.name != null ? `${activation.name}` : null,
      advertiser_id: ((_c = (_b = activation == null ? void 0 : activation.settings) == null ? void 0 : _b.advertisement) == null ? void 0 : _c.id) ?? null,
      advertiser_name: ((_e = (_d = activation == null ? void 0 : activation.settings) == null ? void 0 : _d.advertisement) == null ? void 0 : _e.name) ?? null
    };
  }
  return {
    ...body,
    utm_source: utmParams == null ? void 0 : utmParams.utm_source,
    utm_campaign: utmParams == null ? void 0 : utmParams.utm_campaign,
    utm_content: utmParams == null ? void 0 : utmParams.utm_content,
    utm_term: utmParams == null ? void 0 : utmParams.utm_term,
    utm_medium: utmParams == null ? void 0 : utmParams.utm_medium,
    time: String(Date.now()),
    TLD: window.location.host,
    URL: window.location.href,
    env,
    sess: sessionId,
    agent,
    mobile: isMobile,
    dist: distribution.id,
    distName: distribution.name,
    organization: organizationId,
    // SH: advertiser_* fields implementation was broken.
    // Matt confirmed they are not verified, so they will be disabled for now
    orientation: getOrientation(),
    window_size: { x: window.innerWidth, y: window.innerHeight },
    is_auto: isAutoplay,
    query_string: null,
    // Unused legacy field
    interactive: isInteractive ?? false,
    pixel_id: pixelId,
    video_url: videoUrl
  };
}
export {
  createLegacyPayload
};
